import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';

import Notification from '../../notification';
import styles from './styles.css';

const { gTagEvent } = require('../../../../lib/global-site-tag').default;

export default function ShareReviewButton() {
  const handleOnShareClick = async () => {
    gTagEvent('Reviews Card', 'Shared A Review');
    navigator.clipboard.writeText(window.location.href);
    Notification.success('Link copied to your clipboard.');
  };

  return (
    <FontAwesomeIcon
      icon={faShareAlt}
      className={styles.share}
      onClick={handleOnShareClick}
    />
  );
}
